import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleGuard } from '../../guard/auth-guard/role.guard';
import { Role } from '../../core/enums/role.enum';
import { alteracoesNaoSalvasGuard } from '../../core/guards/alteracoes-nao-salvas.guard';

const TODAS_PERMISSOES_TIPO_PAGAMENTO = [
  Role.CONFIG_TIPO_PAGAMENTO_VISUALIZAR,
  Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR,
  Role.CONFIG_TIPO_PAGAMENTO_ATIVAR_INATIVAR,
];

const BASE = 'pagamento/configurar-tipos-pagamentos';
const BREADCRUMB_BASE = [
  { label: 'Pagamento', url: '/pagamento' },
  { label: 'Configurar Tipos de Pagamentos', url: `/${BASE}` },
];

export const configurarTiposPagamentosRoutes: Routes = [
  {
    path: BASE,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: TODAS_PERMISSOES_TIPO_PAGAMENTO,
      breadcrumb: BREADCRUMB_BASE,
    },
    loadComponent: () =>
      import('./lista/tipos-pagamento-lista.component').then((m) => m.TiposPagamentoListaComponent),
  },
  {
    path: `${BASE}/bolsa/cadastrar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Cadastrar Bolsa' }],
    },
    loadComponent: () =>
      import('./bolsa-form/bolsa-form.component').then((m) => m.BolsaFormComponent),
  },
  {
    path: `${BASE}/bolsa/:id/editar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Editar Bolsa' }],
    },
    loadComponent: () =>
      import('./bolsa-form/bolsa-form.component').then((m) => m.BolsaFormComponent),
  },
  {
    path: `${BASE}/bolsa/:id/visualizar`,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: TODAS_PERMISSOES_TIPO_PAGAMENTO,
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Visualizar Bolsa' }],
    },
    loadComponent: () =>
      import('./bolsa-form/bolsa-form.component').then((m) => m.BolsaFormComponent),
  },
  {
    path: `${BASE}/ajuda-custo/cadastrar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Cadastrar Ajuda de Custo de Instalação' }],
    },
    // Ajuda de Custo de Instalação — cadastro e edição versionados por vigência.
    loadComponent: () =>
      import('./ajuda-custo-instalacao-form/ajuda-custo-instalacao-form.component').then(
        (m) => m.AjudaCustoInstalacaoFormComponent,
      ),
  },
  {
    path: `${BASE}/ajuda-custo/:id/editar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Editar Ajuda de Custo de Instalação' }],
    },
    loadComponent: () =>
      import('./ajuda-custo-instalacao-form/ajuda-custo-instalacao-form.component').then(
        (m) => m.AjudaCustoInstalacaoFormComponent,
      ),
  },
  {
    path: `${BASE}/ajuda-custo/:id/visualizar`,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: TODAS_PERMISSOES_TIPO_PAGAMENTO,
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Visualizar Ajuda de Custo de Instalação' }],
    },
    loadComponent: () =>
      import('./ajuda-custo-instalacao-form/ajuda-custo-instalacao-form.component').then(
        (m) => m.AjudaCustoInstalacaoFormComponent,
      ),
  },
  // Ajuda de Custo do MAAv — mesmo componente da Ajuda de Custo, rota própria apenas para
  // exibir o breadcrumb correto (o breadcrumb é estático por rota; a rota compartilhada
  // sempre mostrava "de Instalação"). Ver PGPP-443.
  {
    path: `${BASE}/ajuda-custo-maav/cadastrar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Cadastrar Ajuda de Custo do MAAv' }],
    },
    loadComponent: () =>
      import('./ajuda-custo-form/ajuda-custo-form.component').then((m) => m.AjudaCustoFormComponent),
  },
  {
    path: `${BASE}/ajuda-custo-maav/:id/editar`,
    canActivate: [AuthGuard, RoleGuard],
    canDeactivate: [alteracoesNaoSalvasGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: [Role.CONFIG_TIPO_PAGAMENTO_CADASTRAR],
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Editar Ajuda de Custo do MAAv' }],
    },
    loadComponent: () =>
      import('./ajuda-custo-form/ajuda-custo-form.component').then((m) => m.AjudaCustoFormComponent),
  },
  {
    path: `${BASE}/ajuda-custo-maav/:id/visualizar`,
    canActivate: [AuthGuard, RoleGuard],
    data: {
      title: 'Configurar tipos de pagamentos',
      roles: TODAS_PERMISSOES_TIPO_PAGAMENTO,
      breadcrumb: [...BREADCRUMB_BASE, { label: 'Visualizar Ajuda de Custo do MAAv' }],
    },
    loadComponent: () =>
      import('./ajuda-custo-form/ajuda-custo-form.component').then((m) => m.AjudaCustoFormComponent),
  },
];
